/* Independent homepage carousel; no cart, checkout or external API calls. */
if (!customElements.get('zrh-hero')) {
  customElements.define('zrh-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.panels = [...this.querySelectorAll('[data-zrh-panel]')];
      this.tabs = [...this.querySelectorAll('[data-zrh-tab]')];
      if (!this.panels.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.active = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reducedMotion.matches || Boolean(window.Shopify?.designMode);
      this.hovering = false;
      this.focused = false;
      this.pauseButton = this.querySelector('[data-zrh-pause]');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => { this.paused = true; this.show(index); }, options);
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target === undefined) return;
          event.preventDefault(); this.paused = true; this.show(target); this.tabs[target].focus();
        }, options);
      });
      this.pauseButton?.addEventListener('click', () => {
        this.paused = !this.paused; this.updatePause(); this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const panel = event.target.closest('[data-zrh-panel]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) { this.paused = true; this.show(index); }
      }, options);
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) this.paused = true;
        this.updatePause(); this.schedule();
      }, options);
      this.classList.add('is-ready');
      this.show(0);
    }
    show(index) {
      this.active = index;
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.updatePause(); this.schedule();
    }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
    }
    schedule() {
      window.clearTimeout(this.timer);
      if (this.paused || this.hovering || this.focused || document.hidden || this.reducedMotion.matches || this.panels.length < 2) return;
      const seconds = Math.min(12, Math.max(4, Number(this.dataset.interval) || 6));
      this.timer = window.setTimeout(() => this.show((this.active + 1) % this.panels.length), seconds * 1000);
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer); this.abort?.abort(); this.ready = false;
    }
  });
}
